export default __webpack_public_path__ + "static/media/en.c29455bd.svg";